import React from "react";
import ComparisonTable from "./ComparisonTableCredits";
import { getFeatureGroups } from "../../../../../clientServices/workspaceFeaturesCredits";
import { twClassNames } from "../../../helpers/twClassNames";

export const FeatureComparison = ({ planData, fsrc }) => {
    const featureGroups = getFeatureGroups();

    return (
        <div className="flex flex-col gap-6 self-stretch">
            <FeatureTable featureGroups={featureGroups} planData={planData} fsrc={fsrc} />
        </div>
    );
};

const FeatureTable = ({ featureGroups, planData, fsrc }) => {
    const isHighlighted = (feature) => feature.highlight?.includes(fsrc);

    return (
        <>
            {featureGroups.map((group, index) => (
                <div key={index}>
                    <ComparisonTable.SectionHeader text={group.section} />
                    {group.features.map((feature, featureIndex) => {
                        if (feature.subsection) {
                            return (
                                <ComparisonTable.SubsectionHeader
                                    key={featureIndex}
                                    text={feature.subsection}
                                    highlight={isHighlighted(feature)}
                                />
                            );
                        }
                        if (feature.type === "checkmark") {
                            return (
                                <ComparisonTable.RowCheckmark
                                    key={featureIndex}
                                    name={feature.name}
                                    explainerText={feature.explainerText}
                                    values={Object.values(planData).map(
                                        (plan) =>
                                            (plan as { features: Record<string, any> }).features[
                                                feature.key
                                            ] === true
                                    )}
                                    noBorder={feature.noBorder}
                                    highlight={isHighlighted(feature)}
                                    link={feature.link}
                                />
                            );
                        } else if (feature.type === "custom") {
                            return (
                                <ComparisonTable.RowCustom
                                    key={featureIndex}
                                    name={feature.name}
                                    explainerText={feature.explainerText}
                                    noBorder={feature.noBorder}
                                    highlight={isHighlighted(feature)}
                                    link={feature.link}
                                >
                                    {Object.values(planData).map((plan, i) => (
                                        <ComparisonTable.Cell key={i}>
                                            {(plan as { features: Record<string, any> }).features[
                                                feature.key
                                            ] === true ? (
                                                <i
                                                    className={twClassNames(
                                                        "fas text-lg",
                                                        isHighlighted(feature)
                                                            ? "fa-circle-check text-yellow-700"
                                                            : "fa-check text-green-500"
                                                    )}
                                                ></i>
                                            ) : (plan as { features: Record<string, any> })
                                                  .features[feature.key] === false ||
                                              (plan as { features: Record<string, any> }).features[
                                                  feature.key
                                              ] === undefined ? null : (
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: (
                                                            plan as {
                                                                features: Record<string, any>;
                                                            }
                                                        ).features[feature.key]
                                                    }}
                                                ></span>
                                            )}
                                        </ComparisonTable.Cell>
                                    ))}
                                </ComparisonTable.RowCustom>
                            );
                        }
                    })}
                </div>
            ))}
        </>
    );
};
